Librarian.Modules.Email = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["onSubmitClicked", "onClearClick", "onPostRender"],

    options: {
        classPrefix: "modules-email-",
        email: null,
        clearButton: false,
        onPostRender: null,
        buttonText: null,
        defaultText: null,
        subject: null,
        defaultTextColor: null,
        textColor: null
    },

    questionContainerEl: null,

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    destroy: function() {
        if (this.questionContainerEl) {
            $(this.questionContainerEl).destroy();
            this.questionContainerEl = null;
        }

        this.parent();
    },

    onPostRender: function() {
        if (typeof this.options.onPostRender == "function")
            this.options.onPostRender(this.containerEl);
    },

    load: function() {
        if (!this.wrapperEl || !this.options.email)
            return;

        this.parent();

        this.questionContainerEl = new Element("textarea", {
            "class": (this.options.classPrefix || '') + "text",
            "value": this.options.defaultText || Librarian.Lang.getString("resource_email_default")
        }).injectInside(this.containerEl);
        this.questionContainerEl.style.color = this.options.defaultTextColor || "#999";
        var self = this;
        // Clear the default value out of the box when it is clicked into
        this.questionContainerEl.addEvent("focus", function() {
            var value = Librarian.Utils.getElementValue(this);
            if (value == Librarian.Lang.getString("resource_email_default") || value == self.options.defaultText) {
                Librarian.Utils.setElementValue(this, '');
                this.style.color = self.options.textColor || "#454545";
            }

            return false;
        }.bind(this.questionContainerEl));

        // If the box is empty when it is clicked out of, restore the default value
        this.questionContainerEl.addEvent("blur", function () {
            var value = Librarian.Utils.getElementValue(this);
            if (value.length == 0) {
                Librarian.Utils.setElementValue(this, self.options.defaultText || Librarian.Lang.getString("resource_email_default"));
                this.style.color = self.options.defaultTextColor || "#999";
            }

            return false;
        }.bind(this.questionContainerEl));

        var buttonEl = new Element("div", {
            "class": (this.options.classPrefix || '') + "send",
            "html": ((this.options.buttonText === false) ? '' : this.options.buttonText || Librarian.Lang.getString("resource_email_button"))
        }).injectInside(this.containerEl);

        if (this.options.clearButton) {
            var clearButtonEl = new Element("div", {
                "class": (this.options.classPrefix || '') + "clear",
                "text": Librarian.Lang.getString("clear")
            }).injectInside(this.containerEl);
            clearButtonEl.addOnClick(this.onClearClick);
        }

        this.onPostRender();

        buttonEl.addOnClick(this.onSubmitClicked);
    },

    onSubmitClicked: function() {
        var message = Librarian.Utils.getElementValue(this.questionContainerEl),
            defaultValue = this.options.defaultText || Librarian.Lang.getString("resource_email_default");      
        // Don't send the default value
        if (message == defaultValue) {
            Librarian.Utils.notification(Librarian.Lang.getString("resource_email_nochange"));
            return;
        }

        // Replace new lines with line breaks to keep formatting
        message = message.replaceAll("\r\n", "<br/>")
                         .replaceAll("\r", "<br/>")
                         .replaceAll("\n", "<br/>");

        var eventInfo = new Librarian.Events.Event();
        eventInfo.name = this.options.subject || this.options.title + " Message";
        eventInfo.messagebody = message;
        eventInfo.exectime = new Date();

        var emails = this.options.email.split(';');
        for (var i = emails.length; i--;) {
            var recipientInfo = new Librarian.Contacts.Contact();
            recipientInfo.email = emails[i].trim();
            eventInfo.addRecipient(recipientInfo);
        }

        Librarian.Events.sendEvent(eventInfo,
        // Success
            function() {
                Librarian.Utils.notification(Librarian.Lang.getString("resource_email_sent"));
                // Clear the question when it has successfully sent
                Librarian.Utils.setElementValue(this.questionContainerEl, defaultValue);
                this.questionContainerEl.style.color = self.options.defaultTextColor || "#999";
            }.bind(this),
        // Failure
            function() {
                Librarian.Utils.error(Librarian.Lang.getString("resource_email_failed"));
            });
    },

    onClearClick: function() {
        if (!this.questionContainerEl)
            return;

        this.questionContainerEl.set("text", Librarian.Lang.getString("resource_email_default"));
        this.questionContainerEl.modified = true;
    }
});